<template>
    <div class="relative">
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.9387 1.83539L29.9464 1.83715L29.9541 1.83878C31.9701 2.26679 33.8187 3.27061 35.2754 4.72849C36.7322 6.18637 37.7346 8.03566 38.1611 10.052L38.1628 10.0603L38.1647 10.0685C38.6573 12.2181 39 15.847 39 20C39 24.1528 38.6574 27.7784 38.1646 29.9318L38.1628 29.9398L38.1611 29.9479C37.7342 31.965 36.7308 33.8149 35.2729 35.2729C33.8149 36.7308 31.965 37.7342 29.9479 38.1611L29.9397 38.1628L29.9315 38.1647C27.7819 38.6573 24.153 39 20 39C15.8472 39 12.2216 38.6574 10.0682 38.1646L10.0602 38.1628L10.0521 38.1611C8.03496 37.7342 6.1851 36.7308 4.72714 35.2729C3.26918 33.8149 2.26583 31.965 1.83891 29.9479L1.83718 29.9397L1.83531 29.9315C1.34265 27.7819 1 24.153 1 20C1 15.8472 1.34262 12.2216 1.83539 10.0682L1.8372 10.0602L1.83889 10.0523C2.26626 8.03427 3.27054 6.18382 4.7297 4.72577C6.18886 3.26773 8.04007 2.26487 10.0584 1.83905L10.0669 1.83725L10.0754 1.83531C12.225 1.34265 15.8539 1 20.0069 1C24.1597 1 27.7853 1.34262 29.9387 1.83539Z"
                stroke="#E4E4E7"
                stroke-width="2"
            />
        </svg>

        <svg
            class="left-1.5 top-1.5 absolute"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.33333 2.33325V6.99992M18.6667 2.33325V6.99992M24.5 16.3333V6.99992C24.5 6.38108 24.2542 5.78759 23.8166 5.35C23.379 4.91242 22.7855 4.66659 22.1667 4.66659H5.83333C5.21449 4.66659 4.621 4.91242 4.18342 5.35C3.74583 5.78759 3.5 6.38108 3.5 6.99992V23.3333C3.5 23.9521 3.74583 24.5456 4.18342 24.9832C4.621 25.4208 5.21449 25.6666 5.83333 25.6666H15.1667M3.5 11.6666H24.5M18.6667 23.3333L21 25.6666L25.6667 20.9999"
                stroke="url(#paint0_linear_2602_3125)"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2602_3125"
                    x1="5.90722"
                    y1="4.66712"
                    x2="23.7571"
                    y2="22.9582"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF8D47" />
                    <stop offset="0.147634" stop-color="#FF7447" />
                    <stop offset="0.454086" stop-color="#FF4247" />
                    <stop offset="0.636926" stop-color="#E92A5B" />
                    <stop offset="0.740367" stop-color="#DD1C67" />
                    <stop offset="0.842991" stop-color="#D31071" />
                    <stop offset="1" stop-color="#CF0283" />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>

<script setup lang="ts"></script>
